import React from 'react';
import logo from '../Assets/Freespace - Navy.png'
import './style.css';
const Freespace = ({url}) => (
  <div className="freespace">
    <img src={logo} alt=""/>
  </div>
);
export default Freespace;